import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RecurringTaskRunner } from './recurring-task.runner';
import { IRunnerOptions } from './models/i-runner.options';
import { FetchStrategyResolver } from './fetch-strategies/fetch-strategy.resolver';

@Injectable({ providedIn: 'root' })
export class RecurringTaskRunnerFactory {
  private defaultRunnerOptions: IRunnerOptions<any>;

  public constructor(private readonly runnerStrategyResolver: FetchStrategyResolver) {
    this.defaultRunnerOptions = { canBeResumedAndPaused: false };
  }

  // tslint:disable-next-line:unified-signatures
  public createRunner<TParameters, TData = void>(
    fetchData: (parameters: TParameters, intervalId: number, preload: boolean) => Observable<TData>,
  ): RecurringTaskRunner<TParameters, TData>;
  // tslint:disable-next-line:unified-signatures
  public createRunner<TParameters, TData = void>(
    fetchData: (parameters: TParameters, intervalId: number, preload: boolean) => Observable<TData>,
    // eslint-disable-next-line @typescript-eslint/unified-signatures
    runnerOptions: IRunnerOptions<TParameters>,
  ): RecurringTaskRunner<TParameters, TData>;
  // tslint:disable-next-line:unified-signatures
  public createRunner<TParameters, TData = void>(
    fetchData: (parameters: TParameters, intervalId: number, preload: boolean) => Observable<TData>,
    runnerOptions?: IRunnerOptions<TParameters>,
  ): RecurringTaskRunner<TParameters, TData> {
    const options = runnerOptions ? { ...this.defaultRunnerOptions, ...runnerOptions } : this.defaultRunnerOptions;

    return new RecurringTaskRunner<TParameters, TData>(this.runnerStrategyResolver, fetchData, options);
  }
}
